import type { AssistantPageContext } from '@components/Assistant/assistantPageContext'
import { placementQuestionText } from '@components/Assistant/placements/questionText'

/**
 * The tool of the Case history skill. Without it K-Assist cannot read a case's history, so the
 * Case history neither offers "Ask K-Assist" nor its quick questions.
 */
export const CASE_HISTORY_TOOL = 'get_case_activity'

/** What the Case history's K-Assist pane offers to ask with one click. */
export const HISTORY_QUICK_QUESTIONS = [
  'Who sent the paperwork?',
  'Who changed the case status, and what else changed in that save?',
  'What changed on this case today?',
  'Which emails failed, and which action sent them?',
  'Who changed the specialist?',
] as const

/**
 * The text a quick question is sent as. The case on screen is the question's context (the case
 * screen behind the History modal, or the History page itself): the question is sent as it is.
 * When that context is not there (the user removed the Context chip), the case number goes along
 * in the text, so "this case" still names the case whose history is open. The case-history case
 * of the placements' own rule (placementQuestionText), which the K-Assist pane uses.
 */
export const historyQuestionText = (
  question: string,
  caseId: string | null | undefined,
  caseNumber: string | null | undefined,
  context: AssistantPageContext | null
) =>
  placementQuestionText(
    question,
    { type: 'case', id: caseId ?? '', label: caseNumber ?? undefined },
    context
  )
